<template>
  <v-container>
    <v-carousel
      height="auto"
      hide-delimiter-background
      light
      :show-arrows="false"
    >
      <v-carousel-item
        v-for="(story,i) in stories"
      >
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" md="10" class="pb-12">
              <v-hover
                v-slot:default="{ hover }"
              >
              <v-card
                :to="{ name: 'article', params: { id: story.article_link.slug }}"
                min-height="300"
                class="transition-swing"
                :class="`elevation-${hover ? 24 : 2}`"
                >
                <v-row>
                  <v-col class="py-0" cols="12" md="4">
                    <v-img
                      class="rounded-l"
                      height="300"
                      :src="'https://res.cloudinary.com/twodm/image/fetch/' + story.customer_image.url"
                    ></v-img>
                  </v-col>
                  <v-col cols="12" md="8" class="d-flex justify-space-between flex-column">
                      <div>
                        <v-list-item three-line class="text-left">
                          <v-list-item-content>
                            <div class="overline mb-4">
                              <v-img
                                width="100"
                                :src="'https://res.cloudinary.com/twodm/image/fetch/' + story.brand_logo.url" />
                            </div>
                            <prismic-rich-text :field="story.testimonial" />
                            <v-list-item-title class="font-weight-black">{{ story.customer_name[0].text }}</v-list-item-title>
                            <v-list-item-subtitle>{{ story.job_title[0].text }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                    <v-card-actions>
                      <v-spacer></v-spacer><v-btn text>Read story</v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
export default {
  name: 'CustomerStory',
  props: {
    stories: Array,
  },
  data() {
    return {
      items: [
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
        },
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
        },
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
        },
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>
